import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideMenuButtonComponent } from './side-menu-button.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
    declarations: [
        SideMenuButtonComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule
    ],
    exports: [
        SideMenuButtonComponent
    ]
})
export class SideMenuButtonModule {}
